<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">无法获取身份信息</div>
      <div class="sub-title">您限制了广告标识，需开启才能正常使用，请
前往手机“设置”：设置-隐私-广告-限制广告
跟踪（关闭此选项）</div>
      <div class="btn-middle retry" @click='hide'>重试</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 223px;
    padding: 30px 20px;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .retry {
      margin: 0 auto;
    }
  }
</style>
<script>
  import Dialog from 'components/Dialog'
  export default {
    components: {
      Dialog
    },
    methods: {
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      }
    }
  }
</script>
